import React from "react";
import "./ProductFilter.scss";
export function ProductFilter({ label, defaultChecked, onClick }) {
    return (React.createElement("div", { className: "k-filter dropdown-item" },
        React.createElement("label", { onClick: onClick, htmlFor: label, "data-text": label, className: "k-topbar--label" },
            React.createElement("span", null, label),
            React.createElement("input", { id: label, defaultChecked: defaultChecked, type: "radio", name: "category", className: "radio" }))));
}
